import { Config } from "./types";

const config: Config = {
  appHost: "https://demo-corporates.ctv.staging-traveloka.com",
  auth: {
    audience: "https://tvlk/ctv",
    domain: "tvlk-dev.auth0.com",
    clientId: "NqjzaMttt4KDsr5ehgly88cses607yJA",
    maxAge: 43200,
  },
  amplify: {
    Auth: {
      Cognito: {
        userPoolId: "ap-southeast-1_DKJ78n7hI",
        userPoolClientId: "361mlb5thatpiuapuocj43tj2f",
        signUpVerificationMethod: "code",
        loginWith: {
          oauth: {
            domain: "ctv-stg.auth.ap-southeast-1.amazoncognito.com",
            scopes: ["email", "profile", "openid"],
            redirectSignIn: [
              "https://demo-corporates.ctv.staging-traveloka.com/",
            ],
            redirectSignOut: [
              "https://demo-corporates.ctv.staging-traveloka.com/",
            ],
            responseType: "code",
          },
        },
      },
    },
  },
  apiHost: {
    search: "https://demo-search-api.ctv.staging-traveloka.com/",
    booking: "https://demo-booking-api.ctv.staging-traveloka.com/",
    refund: "https://demo-refund-api.ctv.staging-traveloka.com/",
    management: "https://demo-management-api.ctv.staging-traveloka.com/",
    content: "https://api.cnt.traveloka.com/",
    data: "https://tracking.stg.tvlk-data.com/",
    "search-production": "https://search-api.ctv.traveloka.com/",
    "flight-static": "https://management-api.ctv.traveloka.com/",
    "mfa-sec-gateway": "https://management-api.ctv.staging-traveloka.com/",
  },
  datadog: {
    // All empty strings are intentional.
    applicationId: "",
    // @ts-ignore Not sure why, but we need this value.
    clientToken: "",
    defaultPrivacyLevel: "mask",
    env: "",
    service: "corporate-travel-web",
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionReplaySampleRate: 100,
    sessionSampleRate: 10,
    site: "datadoghq.com",
    trackLongTasks: true,
    trackResources: true,
    trackUserInteractions: true,
  },
  mock: {
    enabled: false,
  },
  securePayment: "https://payfrm.pay.staging-traveloka.com",
  secrets: {
    GENERATE_TNC_KEY: "f306e",
    REQUEST_TNC_SECRET_CODE: "yUR6Guw8oC",
  },
  s3: {
    AWS_REGION: "ap-southeast-1",
    AWS_S3_BUCKET: "ctv-config-981500889694-27f49f41460ae1e1",
  },
};

export default config;
